export class AffiliateBaseView {
    id: number;
    name: string;
    color: string;
    affiliationCode: string;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? "";
        // Le backend renvoie `colors` (liste, colonne COLORS). Comme le legacy (getColor(0)),
        // on prend la 1re couleur stockée et on normalise le préfixe #.
        const rawColor = data?.colors?.[0] ?? data?.color ?? "";
        this.color = rawColor ? (rawColor.startsWith("#") ? rawColor : `#${rawColor}`) : "";
        this.affiliationCode = data?.affiliationCode ?? "";
    }
}